import { render, staticRenderFns } from "./MediaColumn.vue?vue&type=template&id=38303990&scoped=true&"
import script from "./MediaColumn.vue?vue&type=script&lang=js&"
export * from "./MediaColumn.vue?vue&type=script&lang=js&"
import style0 from "./MediaColumn.vue?vue&type=style&index=0&id=38303990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38303990",
  null
  
)

export default component.exports